// 引入 axios
import axios from "axios";
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import Cookies from "js-cookie";

//传送json格式的get请求
export const request = (obj) => {
  console.log({
    url: `/api${obj.url}`,
    method: obj.method,
    headers: {
      'Content-Type': 'application/json',
      "Authorization": Cookies.get("token") == null? '': ("Bearer " + Cookies.get("token"))
    },
    params: obj.params,
  })
  return axios({
    url: `/api${obj.url}`,
    method: obj.method,
    headers: {
      'Content-Type': 'application/json',
      "Authorization": Cookies.get("token") == null? '': ("Bearer " + Cookies.get("token"))
    },
    params: obj.params,
  }).then(res => {
    return res.data
  })
}

//传送json格式的get请求
export const getRequest=(url,params)=>{
  console.log(params)
  return axios({
    method:'POST',
    url:`api${url}`,
    headers: {
      'Content-Type': 'application/json'
    },
    params:params,
  })
}





// 获取最新网站新闻列表
export function getNewsList(query) {
  return request({
    url: '/web/getNewsList',
    method: 'get',
    params: query
  })
}
// 获取新闻详情
export function getNewsDetail(id) {
  return request({
    url: '/web/getNewsDetail/' + id,
    method: 'get'
  })
}
//站点信息
export function getSiteInfo() {
  return request({
    url: '/web/getSiteInfo',
    method: 'get'
  })
}
//内容详情
export function getContentDetail(id) {
  return request({
    url: '/web/getContentDetail/' + id,
    method: 'get'
  })
}
export function getAboutUs() {
  return request({
    url: '/web/getAboutUs',
    method: 'get'
  })
}
export function getChaiemanSpeech() {
  return request({
    url: '/web/getChaiemanSpeech',
    method: 'get'
  })
}
export function getCompanyIntroduction() {
  return request({
    url: '/web/getCompanyIntroduction',
    method: 'get'
  })
}
export function getCorporateCulture() {
  return request({
    url: '/web/getCorporateCulture',
    method: 'get'
  })
}
export function getTeamShow() {
  return request({
    url: '/web/getTeamShow',
    method: 'get'
  })
}
export function getMerchantFranchise() {
  return request({
    url: '/web/getMerchantFranchise',
    method: 'get'
  })
}


export function getPruductInfo(id) {
  return request({
    url: '/web/getPruductInfo/' + id,
    method: 'get'
  })
}

export function getMerchantInfo(id) {
  return request({
    url: '/web/getMerchantInfo/' + id,
    method: 'get'
  })
}

export function getVipInfo(id) {
  return request({
    url: '/web/getVipInfo/' + id,
    method: 'get'
  })
}

export function getMessageInfo(id) {
  return request({
    url: '/web/getMessageInfo/' + id,
    method: 'get'
  })
}

export function getBannerInfo(id) {
  return request({
    url: '/web/getBannerInfo/' + id,
    method: 'get'
  })
}

//登录
export function login(type,email, password,phone) {
  return request({
    url: '/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {type, email, password,phone }
  })
}

//注册
export function register(lang,type,nickname, email, password, code,invitcode,phone,appfrom) {
  return request({
    url: '/register?f=' + appfrom + '&lang=' + lang,  // 这里改成动态 appfrom
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: { type,nickname, email, password, code,invitcode,phone }
  })
}

//发送验证码
export function sendEmailCode(lang,type,email,appfrom) {
  return request({
    url: '/common/email/code?f=' + appfrom + '&lang='+lang,
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {type, email }
  })
}

//获取国家代码
export function getCountry() {
  var register_show=1;
  return request({
    url: '/common/country',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {register_show}
  })
}

//用户信息
export function getMemberInfo() {
  return request({
    url: '/member/info',
    method: 'post'
  })
}

//校验用户邮箱/手机号
export function chekcMemberEmialPhone(type,code) {
  return request({
    url: '/member/checkcode',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {type,code }
  })
}


//用户信息更新
export function memberUpdate(avatar,nickname,email,phone,gender) {
  return request({
    url: '/member/update',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {avatar,nickname, email,phone,gender }
  })
}

//修改邮箱/号码
export function updateEmailPhone(type,code,value) {
  return request({
    url: '/member/update/email_phone',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    params: {type,code, value }
  })
}

//商家入驻申请
export function checkInCreate(first_name,last_name,email,mobile_area_code,phone,merchant_name,licence_pic) {
  return request({
    url: '/merchant/checkin/create',
    method: 'post',
    params: {first_name,last_name,email,mobile_area_code,phone,merchant_name,licence_pic}
  })
}

//查询商家入驻申请详情
export function getCheckInInfo() {
  return request({
    url: '/merchant/checkin/info',
    method: 'post'
  })
}